import React from 'react';
import {useCallback, useEffect, useState} from 'react';

const RadioGroupSelButtons= ({name, items, callBack, defaultValue}) => {
    const [options, setoptions] = useState([]);
    const [selected, setselected] = useState(defaultValue);
    const [openDrop, setopenDrop] = useState(false);

    const toggleDrop = useCallback(() => setopenDrop(!openDrop), [openDrop]);

    const changeSelect = useCallback(
        (value) => (
            e,
        ) => {
            !!e && e.preventDefault();
            if (value) {
                setselected(value);
                const valToSend = {[name]: value.val};
                callBack(valToSend);
                toggleDrop();
            }
            return;
        },
        [callBack, name, toggleDrop],
    );


    useEffect(() => {
        const optionsRes = items.enum.reduce(
            (res, elem, idx) => [...res, {val: elem, desc: items.enumDesc[idx]}],
            [],
        );
        setoptions(optionsRes);
    }, [items]);

    return (
        <div className="group-layout">
            {options.map((elem, idx) => (
                <button
                    key={idx}
                    className={selected === elem.val ? 'button-dash__selected' : 'button-dash__unselected'}
                    onClick={changeSelect(elem.val)}
                >
                    {elem.desc}
                </button>
            ))}
        </div>
    );
};

export default RadioGroupSelButtons;
